module["exports"] = [
  "vägen",
  "gatan",
  "gränden",
  "gärdet",
  "allén"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/street_suffix.js
// module id = 1550
// module chunks = 1